import * as React from 'react';
import { connect } from 'react-redux';
import { createRouteNodeSelector } from 'redux-router5';
import { navigate } from '~/router';

import { UserRole } from '~/apps/shared/consts';
import SideSubMenu from '~/common/menu/SideSubMenu';


function SettingsSubMenuContainer(props) {
  const { route } = props;

  let items = [
    {
      text: 'Account',
      isActive: route.name.startsWith('support.settings.account'),
      onClick: (e) => navigate('support.settings.account'),
    },
    {
      text: 'Logout',
      isActive: route.name.startsWith('logout'),
      onClick: (e) => navigate('logout'),
    },
  ];

  return (
    <SideSubMenu items={items} />
  );
}


const mapStateToProps = (state) => {
  const routeNodeSelector = createRouteNodeSelector('support');

  return {
    auth: state.shared.auth,
    ...routeNodeSelector(state),
  }
};

export default connect(mapStateToProps)(SettingsSubMenuContainer);
